import styled from "styled-components";

export const Main = styled.div`
  height: 30rem;

  .loading {
    margin: 10rem auto;
  }
`;

export const MyAccountSection = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0 2.5%;

  .right-side {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80rem;

    .avatar {
      width: 25rem;
      height: 25rem;
      border-radius: 50%;
      background: ${(props) => props.theme.colors.GREY_2};
    }

    .user-info {
      h3 {
        font-size: 4.6rem;
        font-weight: 700;
        margin: 2rem 0;
      }
      h5 {
        font-size: 4rem;
        font-weight: 600;
        span {
          color: ${(props) => props.theme.colors.GREEN};
        }
      }
    }
  }

  .left-side {
    display: flex;
    flex-direction: column;

    .margin-top-2 {
      margin-top: 2rem;
    }
  }
`;

export const SubscriptionsOfServiceTypeContainer = styled.div`
  margin: 10rem 0;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 6rem;

    h5 {
      font-size: 3.8rem;
      font-weight: 800;
    }

    hr {
      margin: 0 3rem;
      border: none;
      width: 100%;
      height: 0.4rem;
      background-color: ${(props) => props.theme.colors.GREY_2};
    }
  }
`;

export const SubscriptionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  height: 28rem;
  width: 70%;
  padding: 4rem 8rem;
  border-radius: 2rem;
  background: ${(props) => props.theme.colors.GREY_1};
  .head {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      height: 6rem;
      padding: 2rem;
      border-radius: 1rem;
      background-color: ${(props) => props.theme.colors.WHITE};
    }

    h6 {
      font-size: 3.6rem;
      font-weight: 400;
      margin-right: 2rem;
    }
  }
  .price {
    font-size: 3.2rem;
  }
`;

export const SubscriptionModalContainer = styled.section`
  background-color: ${(props) => props.theme.colors.WHITE};
  width: 45%;
  min-height: 30vh;
  border-radius: 2rem;
  box-sizing: border-box;
  padding: 10rem 6rem 4rem;
`;

export const SubscriptionTypeModalBodyContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  h1 {
    font-size: 3rem;
    span {
      color: ${(props) => props.theme.colors.BLUE};
      text-decoration: underline;
    }
  }

  .buttons-container {
    align-self: flex-end;
    justify-self: flex-end;
    margin-top: auto;
    button {
      margin: 0 2rem;
    }
  }
`;

export const BillTypeBodyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  filter: ${(props) => props.isloading && "blur(2px)"};

  h1 {
    font-size: 4rem;
    text-align: center;
  }

  .buttons-container {
    padding-top: 8rem;
    align-self: flex-end;
    justify-self: flex-end;
    margin-top: auto;
    button {
      margin-right: 2rem;
    }
  }

  .loading {
    margin: 10rem auto;
  }
`;

export const BillInvoiceContainer = styled.h1`
  font-size: 3.6rem !important;
  text-align: right !important;

  span {
    color: ${(props) => props.theme.colors.SELECTED};
  }
`;
